module.exports = __webpack_public_path__ + "media/fonts/UHC_Sans/UHCSans-Bold-8f0640ad60a8c8af00a78ad89774e8fa.eot";